import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DatePicker from '../components/dateRelated/DatePicker';
import Carousel from '../components/graphPageRelated/Carousel';
import { useGraphData } from '../helpers/useGraphData';
import { useTargets } from '../helpers/useTargets';
import { endpointMapping } from '../helpers/endpointMapping';
import '../styles/Dashboard.css';
import Loader from '../components/graphPageRelated/Loader';

const useStyles = makeStyles({
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 50px',
    backgroundColor: '#f8fbff',
    marginBottom: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  dashboardTitle: {
    color: '#343a40',
    fontWeight: 'bold',
  }
});

const DashboardPage = () => {
  const classes = useStyles();
  const [selectedDate, setSelectedDate] = useState(moment());
  const history = useHistory();
  const { graphData, isLoading, error, refreshData } = useGraphData(selectedDate);
  const { targets, updateTarget } = useTargets();

  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(moment(date));
    }
  };

  const handleAnalyze = (endpoint, title, target) => {
  console.log('handleAnalyze called with:', { endpoint, title, target });
  
  const route = endpointMapping[endpoint]?.firstLevelFrontendPage;
  console.log('Route found:', route);
  
  const monthYearRouting = endpointMapping[endpoint]?.monthYearRouting;
  
  if(monthYearRouting){
    const monthYearDateField = endpointMapping[endpoint]?.monthYearDateField;
    const monthYearDate = selectedDate.format('MMM-YYYY').toUpperCase();
    const url = `${route}?${monthYearDateField}=${monthYearDate}`;
    console.log('Navigating to (monthYear):', url);
    history.push(url);
    return;
  }
  
  if (route) {
    const encodedDate = encodeURIComponent(selectedDate.toDate().toUTCString());
    const url = `${route}?date=${encodedDate}&endpoint=${endpoint}&title=${encodeURIComponent(title)}&target=${target}`;
    console.log('Navigating to:', url);
    console.log('Current history:', history);
    history.push(url);
  } else {
    console.log('No route found for endpoint:', endpoint);
    console.log('Available endpoints:', Object.keys(endpointMapping));
  }
};

  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="dashboard">
      <Box className={classes.headerContainer}>
        <Typography variant="h6" className={classes.dashboardTitle}>DASHBOARD</Typography>
        <DatePicker selectedDate={selectedDate} onChange={handleDateChange} />
      </Box>
      <Carousel
        graphData={graphData}
        targets={targets}
        updateTarget={updateTarget}
        onAnalyze={handleAnalyze}
      />
    </div>
  );
};

export default DashboardPage;